import React from "react";
import "../css/IAGenerative.css";
import iaImage from "../assets/images/Ia generative.png";
import iaImageEn from "../assets/images/GenerativeEn.jpg";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";

export default function IAGenerative() {
  const { t, language } = useLanguage();
  const navigate = useNavigate();
  
  const handleNavigate = () => {
    navigate("/IA-Générative");
    // Utiliser setTimeout pour s'assurer que la page est chargée avant de scroller
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };
  
  // Utiliser l'image anglaise si la langue est 'en', sinon l'image française
  const generativeImage = language === 'en' ? iaImageEn : iaImage;
  return (
    <section className="ia-gen-section1">
      <div className="ia-header-title">
        <h2 className="ia-main-title">{t('iaGenerativeComponent.main_title')}</h2>
      </div>
      <div className="ia-content">
        {/* IMAGE GAUCHE */}
        <div className="ia-left">
          <img src={generativeImage} alt={t('iaGenerativeComponent.alt')} className="ia-img" />
        </div>

        {/* TEXTE DROITE */}
        <div className="ia-right">
          <h1 className="ia-title">
            {t('iaGenerativeComponent.title')} <span>{t('iaGenerativeComponent.title_highlight')}</span>
          </h1>
          <h2 className="ia-subtitle"
            dangerouslySetInnerHTML={{ __html: t('iaGenerativeComponent.subtitle') }}
          />

          <p className="ia-text" dangerouslySetInnerHTML={{ __html: t('iaGenerativeComponent.description') }}></p>
          <button
            className="ia-link"
            onClick={handleNavigate}
          >
            {t('iaGenerativeComponent.button')}
          </button>
        </div>
      </div>
    </section>
  );
}
